function filterProducts() {
  const CategoryItems = document.querySelectorAll('.filter-category');
  const items = document.querySelectorAll('.content-sizing-area__result');


  //  Select Category
  CategoryItems.forEach(item => {
    item.addEventListener('click', function () {
      let category = this.getAttribute('data-category');
      CategoryItems.forEach(item => {
        item.classList.toggle('category-active', item === this);
      });

      
      if (category === 'all-inserts') {
        startInterval();
        console.log("Category: " + category);
        let insertsHandle = ['Inserti Ultra Boost', 'Inserti Demi Boost', 'Inserti Invisible Lift', 'Inserti Perfect Boost'];
        items.forEach(item => {
            let altText = item.querySelector('img').getAttribute('alt');
            // Check if any of the handles are included in the alt text
            if (insertsHandle.some(handle => altText.includes(handle))) {
                item.style.display = 'flex';
                item.style.opacity = '1';
            } else {
                item.style.display = 'none';
                item.style.opacity = '0';
            }
        });
      }
      else if (category === 'all-bras') {
        startInterval();
        console.log("Category: " + category);
        let insertsHandle = ['Invisibra', 'Sticky Bra', 'Demi Sticky Bra', 'Reggiseno Adesivo Magic Imbottito'];
        items.forEach(item => {
            let altText = item.querySelector('img').getAttribute('alt');
            // Check if any of the handles are included in the alt text
            if (insertsHandle.some(handle => altText.includes(handle))) {
                item.style.display = 'flex';
                item.style.opacity = '1';
            } else {
                item.style.display = 'none';
                item.style.opacity = '0';
            }
        });
      }
      else if (category === 'all-tapes') {
        startInterval();
        console.log("Category: " + category);
        let insertsHandle = ['Magic Breast Lift', 'Riutilizzabili Nastro Body'];
        items.forEach(item => {
            let altText = item.querySelector('img').getAttribute('alt');
            // Check if any of the handles are included in the alt text
            if (insertsHandle.some(handle => altText.includes(handle))) {
                item.style.display = 'flex';
                item.style.opacity = '1';
            } else {
                item.style.display = 'none';
                item.style.opacity = '0';
            }
        });
      }
      
      else if (category === 'ultra-boost-inserts') {
        console.log("Category: " + category);
        items.forEach(item => {
          // if(item.querySelector('img').getAttribute('alt') ==='Inserti Ultra Boost') {
          if (item.querySelector('img').getAttribute('alt').includes('Inserti Ultra Boost')) {
            item.style.display = 'flex';
            item.style.opacity = '1';
          } else {
            item.style.display = 'none';
            item.style.opacity = '0';
          }
        });
      } else if (category === 'demi-boost-inserts') {
        console.log("Category: " + category);
        items.forEach(item => {
          if (item.querySelector('img').getAttribute('alt').includes('Inserti Demi Boost')) {
            item.style.display = 'flex';
            item.style.opacity = '1';
          } else {
            item.style.display = 'none';
            item.style.opacity = '0';
          }
        });
      } else if (category === 'invisible-lift-inserts') {
        console.log("Category: " + category);
        items.forEach(item => {
          if (item.querySelector('img').getAttribute('alt').includes('Inserti Invisible Lift')) {
            item.style.display = 'flex';
            item.style.opacity = '1';
          } else {
            item.style.display = 'none';
            item.style.opacity = '0';
          }
        });
      } else if (category === 'magic-breast-lift') {
        console.log("Category: " + category);
        items.forEach(item => {
          if (item.querySelector('img').getAttribute('alt').includes('Magic Breast Lift')) {
            item.style.display = 'flex';
            item.style.opacity = '1';
          } else {
            item.style.display = 'none';
            item.style.opacity = '0';
          }
        });
      } else if (category === 'invisibra') {
        console.log("Category: " + category);
        items.forEach(item => {
          if (item.querySelector('img').getAttribute('alt').includes('Invisibra')) {
            item.style.display = 'flex';
            item.style.opacity = '1';
          } else {
            item.style.display = 'none';
            item.style.opacity = '0';
          }
        });
      } 
      else if (category === 'sticky-bra') {
        console.log("Category: " + category);
        items.forEach(item => {
          if (item.querySelector('img').getAttribute('alt').includes('BOOMBA Sticky Bra')) {
            item.style.display = 'flex';
            item.style.opacity = '1';
          } else {
            item.style.display = 'none';
            item.style.opacity = '0';
          }
        });
      }
      else if (category === 'demi-sticky-bra') {
        console.log("Category: " + category);
        items.forEach(item => {
          if (item.querySelector('img').getAttribute('alt').includes('Demi Sticky Bra')) {
            item.style.display = 'flex';
            item.style.opacity = '1';
          } else {
            item.style.display = 'none';
            item.style.opacity = '0';
          }
        });
      }
      else if (category === 'magic-padded-sticky-bra') {
        console.log("Category: " + category);
        items.forEach(item => {
          if (item.querySelector('img').getAttribute('alt').includes('Reggiseno Adesivo Magic Imbottito')) {
            item.style.display = 'flex';
            item.style.opacity = '1';
          } else {
            item.style.display = 'none';
            item.style.opacity = '0';
          }
        });
      }
      else if (category === 'perfect-boost-inserts') {
        console.log("Category: " + category);
        items.forEach(item => {
          if (item.querySelector('img').getAttribute('alt').includes('Inserti Perfect Boost')) {
            item.style.display = 'flex';
            item.style.opacity = '1';
          } else {
            item.style.display = 'none';
            item.style.opacity = '0';
          }
        });
      } else if (category === 'reusable-body-tape') {
        console.log("Category: " + category);
        items.forEach(item => {
          if (item.querySelector('img').getAttribute('alt').includes('Riutilizzabili Nastro Body')) {
            item.style.display = 'flex';
            item.style.opacity = '1';
          } else {
            item.style.display = 'none';
            item.style.opacity = '0';
          }
        });
      }
    });
  });

  // Radio Selected Active Border
  const labelElements = document.querySelectorAll('.custom-size-cat label.radios--value-button');
  const label2Elements = document.querySelectorAll('.custom-band-cat label.radios--value-button');
  labelElements.forEach(item => {
    item.addEventListener('click', function () {
      startInterval();
      let category = this.getAttribute('data-category');
      labelElements.forEach(item => {
        item.classList.toggle('selected', item === this);
      });
    });
  });

  label2Elements.forEach(item => {
    item.addEventListener('click', function () {
      startInterval();
      let category = this.getAttribute('data-category');
      label2Elements.forEach(item => { // Change from labelElements to label2Elements here
        item.classList.toggle('selected', item === this);
      });
    });
  });

  // Output Selected base on Size Value
  let cupValue;
  let bandValue;
  const CupItems = document.querySelectorAll('.Size');
  CupItems.forEach(item => {
    item.addEventListener('click', function () {
      cupValue = item.value;
      // console.log("cup value: " + cupValue);
      const visibleItems = Array.from(items).filter(item => getComputedStyle(item).display === 'flex');
      items.forEach(item => {
        // console.log(item);
        if (item.getAttribute('data-size') === cupValue || item.getAttribute('data-size') === bandValue) {
          item.style.visibility = "visible";
          item.style.position = "relative";
          item.style.opacity = '1';
        } else {
          item.style.visibility = "hidden";
          item.style.position = "absolute";
          item.style.opacity = '0';
        }
      });
    });
  });

  const BandItems = document.querySelectorAll('.Band');
  BandItems.forEach(item => {
    item.addEventListener('click', function () {
      bandValue = item.value;
      // console.log("band value: " + bandValue);
      const visibleItems = Array.from(items).filter(item => getComputedStyle(item).display === 'flex');
      items.forEach(item => {
        // console.log(item);
        if (item.getAttribute('data-size') === cupValue || item.getAttribute('data-size') === bandValue) {
          item.style.visibility = "visible";
          item.style.position = "relative";
          item.style.opacity = '1';
        } else {
          item.style.visibility = "hidden";
          item.style.position = "absolute";
          item.style.opacity = '0';
        }
      });
    });
  });

  // Duplicated Images Filter Function
  const visibleItems = Array.from(items).filter(item => getComputedStyle(item).display === 'flex');
  const imgSrcCountMap = {};
  visibleItems.forEach(item => {
    const imgElement = item.querySelector('img');
    if (imgElement) {
      const imgSrc = imgElement.src;
      if (imgSrc in imgSrcCountMap) {
        imgSrcCountMap[imgSrc]++;
      } else {
        imgSrcCountMap[imgSrc] = 1;
      }
    }
  });
  console.log('Image Source Counts:', imgSrcCountMap);

  const hiddenDuplicates = {};
  visibleItems.forEach(item => {
    const imgElement = item.querySelector('img');
    if (imgElement) {
      const imgSrc = imgElement.src;
      if (imgSrcCountMap[imgSrc] > 1 && !hiddenDuplicates[imgSrc]) {
        hiddenDuplicates[imgSrc] = true;
        item.style.visibility = 'hidden';
        item.style.position = 'absolute';
        item.style.opacity = '0';
      }
    }
  });

  let totalDuplicates = 0;
  for (const imgSrc in imgSrcCountMap) {
    if (imgSrcCountMap[imgSrc] > 1) {
      totalDuplicates += imgSrcCountMap[imgSrc] - 1;
    }
  }
  const remainingTotal = visibleItems.length - totalDuplicates;
  console.log('Total Duplicates:', totalDuplicates);
  console.log('Remaining Total:', remainingTotal);



  // Filter Specific Images base in Band and Size
  let intervalId;

  function startInterval() {
    intervalId = setInterval(() => {
      const visibleItems = Array.from(items).filter(item => getComputedStyle(item).display === 'flex');
      if (cupValue || bandValue) {
        let imgSrc = [];

        visibleItems.forEach(item => {
          if (item.querySelector('img').getAttribute('src').includes(bandValue + "-" + cupValue)) {
            // console.log(bandValue + "-" + cupValue);
            if (imgSrc.includes(item.querySelector('img').getAttribute('src'))) {
              item.style.visibility = "visible";
              item.style.position = "relative";
              item.style.opacity = '1';
              imgSrc.push(item.querySelector('img').getAttribute('src'));
              console.log(imgSrc.includes(item.querySelector('img').getAttribute('src')));
            }
          } else {
            item.style.visibility = "hidden";
            item.style.position = "absolute";
            item.style.opacity = '0';
          }
        });
      }
    }, 100);
  };
  startInterval();


  // Reset Function
  const resetButton = document.getElementById('reset');
  resetButton.addEventListener('click', function () {
    clearInterval(intervalId);
    items.forEach(item => {
      item.style.visibility = 'visible';
      item.style.position = 'relative';
      item.style.opacity = '1';
      item.style.display = 'flex';
    });

    labelElements.forEach(item => {
      item.classList.remove('selected');
    });

    label2Elements.forEach(item => {
      item.classList.remove('selected');
    });

    CategoryItems.forEach(item => {
      item.classList.remove('category-active');
    });

    const allCategoryItem = Array.from(CategoryItems).find(item => {
      return item.getAttribute('data-category') === 'all';
    });

    if (allCategoryItem) {
      allCategoryItem.classList.add('category-active');
    }

    cupValue = null;
    bandValue = null;
  });
}
filterProducts();